import { render, staticRenderFns } from "./TotalRevenueCurrentMonthCard.vue?vue&type=template&id=7240f7a3&scoped=true&"
import script from "./TotalRevenueCurrentMonthCard.vue?vue&type=script&lang=js&"
export * from "./TotalRevenueCurrentMonthCard.vue?vue&type=script&lang=js&"
import style0 from "./TotalRevenueCurrentMonthCard.vue?vue&type=style&index=0&id=7240f7a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240f7a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VSkeletonLoader})
